/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import { max } from 'date-fns';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const FullyLoadedBarChart = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: 'Depreciation & Amortization',
        data: data.map((item) => Number(item.value)),
        // backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
        backgroundColor: (ctx) => {
          const value = ctx.raw;
          return value < 0 ? "red" : ['#2196F3', '#FFC107', '#00BCD4'];
        },
        // barPercentage:0.6,
        barThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    layout: {
      padding: {
        top: 20,
      },
    },
    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        enabled: true,
        callbacks: {
          label: (ctx) => {
            const val = ctx.parsed?.y ?? ctx.raw;
            return `${ctx.dataset.label}: ${val} Lac`;
          },
        },
      },
      datalabels: {
        color: "black",
        textStrokeColor: "white",
        textStrokeWidth: 4,
        anchor: "end",
        align: "end",
        // rotation: 90, 
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          display:true,
          font: { size: 8 },
          callback: (value) => `${value} Lac`,
        },
        grid: { display: true },
      },
      x: {
        ticks: {
          display: true,
          font: { size: 9 },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '230px'}}>
        <Bar data={chartData} options={options}/>
    </div>
  );
};

export default FullyLoadedBarChart;
